import React, {useContext} from 'react';
import { Context } from './Context';
import OceanGrid from './grid_designs/OceanGrid';
import AviaryGrid from './grid_designs/AviaryGrid';
import BlogTrail from './grid_designs/BlogTrail';


const GridRadio = () => {
    const { gridTheme, handleRadioSelection } = useContext(Context)
    return (

        <div>                                             
            {gridTheme==='sandWater' && <OceanGrid />}
            {gridTheme==='birds' && <AviaryGrid />}
            {gridTheme==='trail' && <BlogTrail />}


            <p className="radioHeader">Some Grid Compositions</p>
            <div className="radioBtnContainer">
                <div>
                    <label>
                        <input  type="radio" 
                                name="gridTheme" 
                                value="trail" 
                                checked={gridTheme==="trail"} 
                                onChange={handleRadioSelection} />
                    Blogtrail</label>
                </div>
                <div>
                    <label>
                        <input  type="radio" 
                                name="gridTheme" 
                                value="sandWater" 
                                checked={gridTheme==="sandWater"} 
                                onChange={handleRadioSelection} />
                    Ocean</label>
                </div>

                <div>
                    <label>
                        <input  type="radio" 
                                name="gridTheme" 
                                value="birds" 
                                checked={gridTheme==="birds"} 
                                onChange={handleRadioSelection} />
                    Aviary</label>
                </div>

            </div>	
            <br />

        </div>
    )
}

export default GridRadio;